import keyMirror from '../../../utilities/keymirror';

const ActionTypes = keyMirror({
  FETCH_RATECARDS_REQUEST: null,
  FETCH_RATECARDS_SUCCESS: null,
  FETCH_RATECARDS_FAILURE: null,
}, 'RATECARDS');

export default ActionTypes;
